import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BANNER_BOTTOM_PADDING } from "../components/ui/BugReporterBanner";
import { useAuthStore } from "../stores/authStore";

export function LandingPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuthStore();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate("/seats", { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <div
      className={`flex min-h-screen flex-col bg-gray-100 ${BANNER_BOTTOM_PADDING}`}
    >
      <div className="flex flex-1 items-center justify-center px-4">
        <div className="w-full max-w-lg text-center">
          <h1 className="mb-3 text-4xl font-bold text-gray-900">Sekitori</h1>
          <p className="mb-2 text-lg text-gray-600">
            オフィス座席予約管理システム
          </p>
          <p className="mb-8 text-sm leading-relaxed text-gray-500">
            Sekitoriは、オフィスのフリーアドレス座席をかんたんに予約・管理できるWebアプリケーションです。空き座席の確認、予約の作成・変更、定期予約の設定がブラウザからすぐに行えます。
          </p>

          <Link
            to="/auth/login"
            className="inline-flex items-center justify-center gap-3 rounded-md border border-gray-300 bg-white px-8 py-3 text-gray-700 shadow-sm transition-colors hover:bg-gray-50"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24" aria-label="Google">
              <title>Google</title>
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            <span>Google でログイン</span>
          </Link>
        </div>
      </div>

      <footer className="py-6 text-center text-xs text-gray-400">
        <Link to="/privacy" className="hover:text-gray-600">
          プライバシーポリシー
        </Link>
      </footer>
    </div>
  );
}
